import { Button } from "@jugl-web/ui-kit";
import React, { ReactNode } from "react";
import { ReactComponent as InfoIcon } from "./assets/info.svg";
import { ReactComponent as ClockIcon } from "./assets/clock.svg";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

export type InactiveChatInputVariant = "disconnected" | "expired";

export const DisconnectedChatInput: React.FC<{
  variant?: InactiveChatInputVariant;
  title: string;
  description: ReactNode;
  buttonProps?: {
    text: string;
    onClick?: () => void;
    isDisabled?: boolean;
  };
}> = ({ variant = "disconnected", title, description, buttonProps }) => {
  const Icon = variant === "expired" ? ClockIcon : InfoIcon;

  return (
    <div className="flex items-center justify-between gap-6 border-0 border-t border-solid border-dark-100 px-8 py-6">
      <div className="flex min-w-0 flex-col gap-2">
        <div className="flex items-center gap-2">
          <Icon className="shrink-0" />
          <span className="font-secondary text-[15px] leading-[150%] font-semibold text-dark">
            {title}
          </span>
        </div>
        <div className="max-w-[600px] font-secondary text-[15px] leading-[140%] text-dark">
          {description}
        </div>
      </div>
      {buttonProps && (
        <Button
          variant="primary"
          size="sm"
          className="shrink-0"
          iconEnd={<ArrowRightIcon />}
          onClick={buttonProps.onClick}
          isDisabled={buttonProps.isDisabled}
        >
          {buttonProps.text}
        </Button>
      )}
    </div>
  );
};
